<div class="select-default">
    <label *ngIf="label!=''">{{label}}</label>
    <select (change)="onChange($event.target.value)" [(ngModel)]="selected" [disabled]="disabled">
        <option hidden value="" disabled selected>{{placeholder}}</option> 
        <option *ngFor="let opt of options" [value]="opt.value" [disabled]="disabledOption(opt)">
            {{opt.title}}
        </option>
    </select>
</div>
